import produce from 'immer';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, emissaoAtestados } from './types';

export const INITIAL_STATE: emissaoAtestados = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): emissaoAtestados {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMISSAO_ATESTADOS_REQUEST: {
				break;
			}

			case Types.EMISSAO_ATESTADOS_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.EMISSAO_ATESTADOS_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EMISSAO_ATESTADOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
